import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Serviciu, ServiciuUpdate } from './servicii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ServiciiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getServiciuUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.getServiciu;
    private getServiciiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.getServicii;
    private getServiciiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.getServiciiActive;
    private getServiciiPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.getServiciiPublic;
    private storeServiciuUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.storeServiciu;
    private updateServiciuUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.updateServiciu;
    private deleteServiciuUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.deleteServiciu;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.changeStatusServiciuActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.servicii.changeStatusServiciuPublic;

    constructor(private http: HttpClient) { }

    getServiciu(id: number) {
        return this.http.get(this.getServiciuUrl + id, this.httpOptions);
    }

    addServiciu(serviciu: Serviciu) {
        return this.http.post(this.storeServiciuUrl, serviciu, this.httpOptions);
    }

    updateServiciu(serviciu: ServiciuUpdate) {
        return this.http.put(this.updateServiciuUrl, serviciu, this.httpOptions);
    }

    deleteServiciu(id: number) {
        return this.http.delete(this.deleteServiciuUrl + id);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getServicii() {
        return this.http.get(this.getServiciiUrl, this.httpOptions);
    }

    getServiciiActive() {
        return this.http.get(this.getServiciiActiveUrl, this.httpOptions);
    }

    getServiciiPublic() {
        return this.http.get(this.getServiciiPublicUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
